export class UserMarketPlace {
    userMarketPlaceId: number;
    deviceMarketPlaceId: number;
}